import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const BILLING_ENDPOINT = 'billing/v1';

export const BASE_URL = `${serverUrl}/${BILLING_ENDPOINT}`;
